export enum EMPLOYEE_DATA_FILE_HISTORY_STATUS {
  OK = 'OK',
  ERROR = 'ERROR',
  PROCESSING = 'PROCESSING',
}

export enum EMPLOYEE_DATA_FILE_HISTORY_STATUS_TRANSLATE {
  OK = 'Ok',
  ERROR = 'Erro',
  PROCESSING = 'Processando',
}

export enum EMPLOYEE_DATA_FILE_HISTORY_STATUS_COLORS {
  OK = '#077d3b',
  ERROR = '#c22937',
  PROCESSING = '#f0bc00',
}
